// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"266":"ad70cca6","373":"d3a83b10","402":"cb7af27b","431":"3056b4ac","531":"84d1e45b","552":"74e45244","816":"b16b257a","855":"4c1ce26d","931":"fc1f2139","940":"fe0d3bef"}[chunkId] + ".chunk.js";
};